module.exports = __webpack_public_path__ + "img/bg_complete_run.d9b43ef9.gif";